import React, { useState, useEffect } from 'react';
import CloseButton from '../../../../sharecomponents/CloseButton';
import Post from '../../../../../utils/Post';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import Verifiers from '../../../../../utils/Verifiers.jsx';

const AgregarCatalogoPlagaEnfermedad = (p) => {
    const update = p.data ? true : false;
    const [data, setdata] = useState({
        id: p.data?.id ?? 0,
        blanco_biologico: p.data?.blanco_biologico_id ?? 0,
        clasificacion: p.data?.clasificacion_id ?? 0,
        forma_evaluacion: p.data?.forma_evaluacion ?? '',
        severidadG1: p.data?.severidadG1 ?? '',
        severidadG2: p.data?.severidadG2 ?? '',
        severidadG3: p.data?.severidadG3 ?? '',
    });
    const close = p.close ?? (() => { });
    const title = p.title ?? '';
    const clasificaciones = p.clasificaciones ?? [];
    const blancosBiologicos = p.blancosBiologicos ?? [];
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    useEffect(() => {

    }, []);

    const APISend = async (action, data) => {
        let resp = await Post(`/mipe/catalogo/${action}`, { ...data }, 'POST', setloader);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Error', 'error');
            return;
        }
        close(resp.data);
    }

    const add = () => {
        if (
            data.blanco_biologico == 0 ||
            data.clasificacion == 0 ||
            data.forma_evaluacion.trim() === '' ||
            data.severidadG1.trim() === '' ||
            data.severidadG2.trim() === '' ||
            data.severidadG3.trim() === ''
        ) {
            Verifiers.activeDialog(setdialog, 'La elección de blanco biológico, clasificación, froma de evaluación, y los tres grados de serveridad son obligatorios', 'Error', 'error');
            return;
        }
        APISend(update ? 'update' : 'add', data);
    }

    const deleteReg = () => APISend('delete', { id: data.id });

    const confirmDelete = () => setdialog({
        tipo: "error",
        show: true,
        title: "CONFIRME PARA CONTINUAR",
        body: "¿Realmente desea eliminar este registro? Esta acción no se puede deshacer.",
        respYes: "Si, eliminar",
        respNot: "Cancelar",
        funct: (resp) => { if (resp) deleteReg(); setdialog({ show: false }) },
        size: 'm'
    })


    const change = (e) => setdata({ ...data, [e.target.name]: e.target.value })

    return (
        <div className='vw-100 vh-100 blur-l dosis p-1' style={{ zIndex: 999, top: 0, left: 0, position: "fixed" }}>
            <CloseButton close={() => close(false)} />
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='col-auto p-1 ps-3 pe-3 round-xxl bg-white shadow h4 text-300'>{title} <span className='text-m text-bold ms-2'>{update ? 'Actualizar' : 'Nuevo'}</span> </div>
                <div className='w-100 m-0 p-0' />
                <div className='bw-800 bg-white shadow-multi round-m p-2 mt-2 mb-5'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='bw-350 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>Blanco biológico</label>
                            <select className='form-control form-control-sm shadow round-m' value={data.blanco_biologico} name='blanco_biologico' onChange={change}>
                                <option value='0' >SELECCIONE UNA OPCIÓN</option>
                                {blancosBiologicos.map((blanco, index) => <option key={index} value={blanco.id}>{blanco.nombre}</option>)}
                            </select>
                        </div>
                        <div className='bw-350 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>Clasificación</label>
                            <select className='form-control form-control-sm shadow round-m' value={data.clasificacion} name='clasificacion' onChange={change}>
                                <option value='0' >SELECCIONE UNA OPCIÓN</option>
                                {clasificaciones.map((clasificacion, index) => <option key={index} value={clasificacion.id}>{clasificacion.clasificacion}</option>)}
                            </select>
                        </div>
                        <div className={'bw-700 mt-2'}>
                            <label className='text-bold text-s w-100 ps-3'>Forma de evaluación</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='forma_evaluacion' type='text' value={data.forma_evaluacion} onChange={change} />
                        </div>
                        <div className={'bw-600 mt-2'}>
                            <label className='text-bold text-s w-100 ps-3'>Severidad grado 1</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='severidadG1' type='text' value={data.severidadG1} onChange={change} />
                        </div>
                        <div className={'bw-600 mt-2'}>
                            <label className='text-bold text-s w-100 ps-3'>Severidad grado 2</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='severidadG2' type='text' value={data.severidadG2} onChange={change} />
                        </div>
                        <div className={'bw-600 mt-2'}>
                            <label className='text-bold text-s w-100 ps-3'>Severidad grado 3</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='severidadG3' type='text' value={data.severidadG3} onChange={change} />
                        </div>
                        <div className='w-100' />
                        {
                            update && <div className='bw-200 mt-3 mb-4'>
                                <button className='btn btn-danger btn-sm w-100 shadow round-xxl text-bold' onClick={confirmDelete}>Eliminar</button>
                            </div>
                        }
                        <div className='bw-350 mt-3 mb-4'>
                            <button className='btn btn-warning btn-sm w-100 shadow round-xxl text-bold' onClick={add}>{update ? 'Actualizar' : 'Agregar'}</button>
                        </div>
                    </div>
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default AgregarCatalogoPlagaEnfermedad;